var Validate = require('validate.js');
var Q = require('../server/unit/qty');
var Formula = require('excel-formula');

Validate.validators.formula = function (value, options, key, attributes) {
  if (value == null || typeof value == 'undefined') {
    return;
  }

  try {
    var formula = Formula.getTokens(value);
  } catch (e) {
      return e.toString();
  }
}

Validate.validators.emptyOrNumeric = function(value, options, key, attributes) {
  if (value === undefined || value === null || value === '') {
    return null; // Empty value is allowed
  } else if (!/^\d+$/.test(value)) {
    return options.message || 'must be a number'; // Numeric validation failed
  } else {
    return null; // Numeric validation passed
  }
};

Validate.validators.samplingInterval = function (value) {
  var interval = Number(value);
  if (interval === 0 || (Number.isInteger(interval) && interval >= 5)) {
    return null;
  }
  return 'must be 0 (no sampling) or at least 5 seconds';
};


Validate.validators.unit = function (value, options, key, attributes) {
  if (
    value == 'int' || 
    value == 'bool' || 
    value == 'str' || 
    value == null || 
    typeof value == 'undefined' || 
    ( typeof value == 'string' && value.trim() === '' ) 
  ) {
    return;
  }

  try {
    var unit = Q(value);
    if (unit.scalar !== 1) {
      return 'Unit definition must not define a quantitiy'
    } else {
      return null;
    }
  } catch (e) {
    if (e instanceof Q.Error) {
      return e.toString();
    }
  }
}

// Step 1: Define the custom validator
function isValidRegex(value, options, key, attributes) {
  if (!value) return;  // Skip validation if value is empty (handle required separately)

  try {
      new RegExp(value); // Attempt to create a regex
      // If no error, the regex is valid, and no message is returned
  } catch (e) {
      // If an error occurs, return a message indicating the regex is invalid
      return "is not a valid regular expression";
  }
}
Validate.validators.isValidRegex = isValidRegex;


module.exports = Validate;
